// extracted by mini-css-extract-plugin
export var businessUnit = "ResourcePost-module--business-unit--71d13";
export var content = "ResourcePost-module--content--911d1";
export var date = "ResourcePost-module--date--59236";
export var download = "ResourcePost-module--download--9a966";
export var downloadButton = "ResourcePost-module--download-button--eabde";
export var grid = "ResourcePost-module--grid--08fcc";
export var header = "ResourcePost-module--header--324d6";
export var image = "ResourcePost-module--image--77761";
export var layout = "ResourcePost-module--layout--7b4ef";
export var meta = "ResourcePost-module--meta--fdbcf";
export var title = "ResourcePost-module--title--d5a10";
export var type = "ResourcePost-module--type--7be89";